module.exports = __webpack_public_path__ + "img/image (21).084d649c.jpg";